import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleEvaluerRisquesIA() {
  return (
    <BlogArticleLayout
      tag="IA & Cybersécurité"
      title="Évaluer les risques IA de votre entreprise : la méthode"
      date="17 décembre 2026"
      ctaTitle="Passez de la méthode à l'action"
      ctaText="Le diagnostic applique cette méthode à votre situation réelle et génère un plan d'action priorisé."
    >
      <p style={s.intro}>
        Face à la diversité des risques liés à l'IA, la tentation est de tout traiter en même temps, ou à
        l'inverse de ne rien traiter faute de savoir par où commencer. Une évaluation structurée permet de
        sortir de ce dilemme.
      </p>

      <h2 style={s.h2}>Étape 1 — Cartographier vos usages réels de l'IA</h2>
      <p>
        Avant d'évaluer un risque, il faut savoir où l'IA intervient réellement dans votre entreprise : outils
        utilisés directement par vos équipes, fonctionnalités IA intégrées dans vos logiciels métier, systèmes
        éventuellement développés en interne. Cette cartographie s'appuie sur la même logique que celle
        décrite dans notre article sur la
        {' '}<Link to="/blog/gouvernance-systemes-ia-entreprise" style={s.link}>gouvernance des systèmes d'IA</Link>.
      </p>

      <h2 style={s.h2}>Étape 2 — Qualifier chaque usage selon sa sensibilité</h2>
      <p>
        Un usage qui traite des données personnelles, des informations financières ou des décisions ayant un
        impact sur des personnes (recrutement, crédit) mérite un examen plus approfondi qu'un usage
        strictement interne et sans donnée sensible.
      </p>

      <h2 style={s.h2}>Étape 3 — Croiser avec les familles de risques identifiées</h2>
      <p>
        Pour chaque usage sensible, vérifiez son exposition aux risques recensés dans notre
        {' '}<Link to="/blog/risques-ia-panorama" style={s.link}>panorama des risques IA</Link> :
        dépendance à un fournisseur, exposition à la prompt injection, risque de fuite de données, absence de
        supervision humaine sur les actions automatisées.
      </p>

      <h2 style={s.h2}>Étape 4 — Décider et documenter le traitement de chaque risque</h2>
      <p>
        Comme pour tout risque cybersécurité, quatre options existent : réduire (mesure technique ou
        contractuelle), accepter (si l'impact est limité), transférer, ou éviter l'usage concerné. Documentez
        ce choix, même sommairement.
      </p>

      <h2 style={s.h2}>Étape 5 — Réévaluer à chaque nouvel usage</h2>
      <p>
        L'adoption de l'IA évolue rapidement dans la plupart des entreprises. Une évaluation figée devient
        obsolète en quelques mois — voir notre article sur le
        {' '}<Link to="/blog/supervision-usages-ia-entreprise" style={s.link}>contrôle et la supervision des usages IA</Link>{' '}
        pour transformer cette évaluation ponctuelle en processus continu.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleEvaluerRisquesIA;
